module.exports = __webpack_public_path__ + "media/images/icons/country_flags/iq-f3ea19bd5955e962cd571ab6b9278aab.svg";